// extracted by mini-css-extract-plugin
export default {"container":"TagList_container__DLryG"};